import React from 'react';
import Button from "components/CustomButton";

function AIAvatarResponse({ url, keepValue, rejectAvatar }) {
	return (
		<>
			<div className='ai-modal-content video-avatar-response'>
				<div>
					<h5>Generated Video</h5>
				</div>
				<video
					style={{ width: '350px' }}
					controls
					autoPlay
					preload="metadata"
					src={url}
				/>
			</div>
			<div className="chat-gpt-footer">
				<Button
					onClick={rejectAvatar}
					buttonClass=" small-reject-btn chat-gpt-response-reject"
				>
					Reject
				</Button>
				<Button
					buttonClass="small-accept-btn me-2 chat-gpt-response-accept"
					onClick={keepValue}
				>
					Accept
				</Button>
			</div>
		</>
	);
}

export default AIAvatarResponse;